import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Store from './store/index'
import './assets/css/reset.css'
import ElementUI from './config/styleConfig/elementConfig'
import Clipboard from 'vue3-clipboard'

const app = createApp(App)

app.config.globalProperties.$state = Store.state
app.use(Clipboard, {
  autoSetContainer: true,
  appendToBody: true,
})
app.use(router).use(ElementUI).mount('#app')
